import React from 'react';
import {StorageKey} from "../../../enums/StorageKey";
import BukkuTooltip from "../../Tooltip";
import {CheckOutlined, CloseOutlined, EyeInvisibleOutlined} from "@ant-design/icons";
import {t} from "@lingui/macro";

function getColumns() {
    return [
        {
            key: 'line',
            width: 55,
            align: 'right',
            fixed: 'left',
            render: (text, record) => record.line,
        },
        {
            key: 'thumbnail_url',
            title: t`Thumbnail`,
            width: 75,
            render: (text, record) => {
                const src = record.thumbnail_url || '/assets/img/product-placeholder.png';
                return (
                    <div style={{textAlign: 'center'}}>
                        <img
                            style={{
                                maxWidth: 50,
                                maxHeight: 50,
                                border: "1px solid #BEBEBE",
                                objectFit: "contain",
                                width: "100%",
                                height: "50px",
                            }}
                            src={src}
                            alt=""
                        />
                    </div>
                );
            },
        },
        {
            title: t`Name`,
            dataIndex: 'name',
            key: 'name',
            width: 200,
            render: (text, record) => (
                <BukkuTooltip
                    title={text}
                    placement="topLeft"
                >
                    <div className="ellipsis-div">
                        <span>{text}</span>
                        &nbsp;
                        {record.is_archived ? <EyeInvisibleOutlined /> : null}
                    </div>
                </BukkuTooltip>
            ),
        },
        {
            title: t`SKU`,
            dataIndex: "sku",
            key: "sku",
            width: 140,
            ellipsis: true,
            render: text => (
                <div className="ellipsis-div">
                    <BukkuTooltip>
                        <span>{text || '-'}</span>
                    </BukkuTooltip>
                </div>
            ),
        },
        {
            title: t`Inventory`,
            dataIndex: 'track_inventory',
            key: 'track_inventory',
            width: 80,
            align: 'left',
            render: text => (text ? <CheckOutlined /> : <CloseOutlined />),
        },
        {
            title: t`Selling`,
            dataIndex: 'is_selling',
            key: 'is_selling',
            width: 60,
            align: 'left',
            render: text => (text ? <CheckOutlined /> : <CloseOutlined />),
        },
        {
            title: t`Buying`,
            dataIndex: 'is_buying',
            key: 'is_buying',
            width: 60,
            align: 'left',
            render: text => (text ? <CheckOutlined /> : <CloseOutlined />),
        },
        // {
        //     title: t`Sale Price`,
        //     dataIndex: "sale_price",
        //     key: "sale_price",
        //     align: 'right',
        //     width: 150,
        //     render: (text) => (
        //         <AmountTd
        //             currency_code={session.company.currency_code}
        //             amount={text}
        //         />
        //     )
        // },
        // {
        //     title: t`Purchase Price`,
        //     dataIndex: 'purchase_price',
        //     key: 'purchase_price',
        //     align: 'right',
        //     width: 150,
        //     render: (text) => (
        //         <AmountTd
        //             currency_code={session.company.currency_code}
        //             amount={text}
        //         />
        //     )
        // },
        // {
        //     title: t`Margin %`,
        //     dataIndex: 'margin_percent',
        //     key: 'margin_percent',
        //     align: 'right',
        //     width: 100,
        //     render: (text, record) => {
        //         if (record) {
        //             const marginPercent =
        //                  ((record.sale_price - record.purchase_price) / record.sale_price * 100);
        // if (isNaN(marginPercent) || marginPercent === null ||
        // marginPercent === -Infinity || marginPercent === Infinity
        // || marginPercent === 100) {
        //                 return '-';
        //             }
        //         return marginPercent.toFixed(2) + '%';
        //         }
        //     }
        // },
        {
            key: 'empty',
        },
    ];
}

export default {
    storageKey: StorageKey.product_group,
    sortable: [
    ],
    required: [
        'line',
        'name',
        'empty',
    ],
    defaulto: [
        'thumbnail_url',
    ],
    hideTitle: [
        'thumbnail_url',
    ],
    getColumns,
};
